module.exports = __webpack_public_path__ + "img/bsc_03.835e25ea.png";